import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { I18nProvider, LOCALES } from './i18n/index.tsx';
import { loadPreferences } from './persistence/preferences.ts';
import './ui/theme.css';
import './ui/screens.css';

/**
 * The language this device last chose, if it is one this build still speaks.
 *
 * Read here rather than inside the provider so that the very first render is already in the right
 * language — a flash of English before Portuguese appears is a bug people notice every time.
 */
const stored = loadPreferences().locale;
const initialLocale = LOCALES.find((code) => code === stored);

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <I18nProvider initialLocale={initialLocale}>
      <App />
    </I18nProvider>
  </StrictMode>,
);
